<template>
    <div>
        <div class="buildingInformation">
            <div class="card mx-auto" style="width: 50rem;">
                <div class="card-body">
                    <h5 class="card-title">Building Information</h5>
                    <p><strong>Building Name : </strong>{{buildingDetails.name}} &nbsp; &nbsp; <strong>Strata No
                        :</strong>{{buildingDetails.strata_no}}</p>
                    <p></p>
                    <p><strong>Address :</strong> {{buildingDetails.address}}&nbsp;{{buildingDetails.post_code}}&nbsp;{{buildingDetails.state}}</p>
                    <p><strong>Latitude :</strong> {{buildingDetails.latitude}} &nbsp; &nbsp; <strong>Longitude
                        : </strong>{{buildingDetails.longitude}}</p>
                    <p></p>
                    <p><strong>Key :</strong> {{buildingDetails.key}}</p>
                    <p><strong>Parking : </strong> {{buildingDetails.parking}}</p>
                    <p><strong>Toilet : </strong> {{buildingDetails.toilet}}</p>
                    <p><strong>Note :</strong> {{buildingDetails.note}}</p>
                </div>
            </div>
        </div>
        <div class="usersAssignedToBuilding ">
            <table class="table table-bordered table-striped table-condensed">
                <thead>
                <th>Name</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Title</th>
                <th>Role</th>
                <th>Remove</th>
                <th>Update</th>
                </thead>
                <tbody>
                <tr v-for="(userDetail,index) in userDetails" v-if="userDetail.user && userDetail.building_role">
                    <td>{{userDetail.user.title +' '+userDetail.user.first_name + ' ' + userDetail.user.last_name}}</td>
                    <td>{{userDetail.user.phone1}}</td>
                    <td>{{userDetail.user.email}}</td>
                    <td><input type="text" maxlength="32" class="form-control addInputField" required
                               placeholder="e.g. Building manager"
                               v-model="userDetail.title"
                        ></td>
                    <td>
                        <select class="form-control" v-model="userDetail.building_role.id" name="building_role_id">
                            <option v-for="(userRole,index) in userRoles" :value="userRole.id">{{userRole.display_name}}
                            </option>
                        </select>
                    </td>
                    <td>
                        <button type="button" class="btn btn btn-outline-primary"
                                v-on:click="confirmPopup('Delete User',userDetail.user.id, index)">Remove
                        </button>
                    </td>
                    <td>
                        <button type="button" class="btn btn btn-outline-primary"
                                v-on:click="updateRole(userDetail.user.id, userDetail.building_role.id, userDetail.title)">Update
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="form-group mx-auto" style="width: 500px ">
            <form class="needs-validation" novalidate v-on:submit.prevent="searchUserByEmail()">
                <div class="form-row">
                    <div class="col-md-10 mb-3">
                        <label for="Email" class="sr-only">Email</label>
                        <input type="email" v-model="searchEmailFormFields.email"
                               name="email" id="email" placeholder="Enter Email To Search"
                               v-bind:class="{ 'is-invalid': error.email }"
                               class="form-control">
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-md-10 mb-3">
                        <button class="btn btn-primary btn-block" type="submit">Search</button>
                    </div>
                </div>
            </form>
            <div style="width: 500px ">
                <transition name="fade">
                    <div class="col-md-10" v-if="response.ifEmailExists">
                        <div class="alert alert-danger" role="alert">User Does not Exist</div>
                    </div>
                </transition>
                <transition name="fade">
                <div class="col-md-10" v-if="response.isRoleUpdated">
                    <div class="alert alert-success" role="alert">{{roleMessage}}</div>
                </div>
            </transition>
            <transition name="fade">
                <div class="col-md-10" v-if="response.IfRoleAssigned">
                    <div class="alert alert-danger" role="alert">{{roleMessage}}</div>
                </div>
            </transition>
            </div>
        </div>
        <div class="emailSearchResults" v-if="response.isEmailResults">
            <table class="table table-bordered table-striped table-condensed">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Phone</th>
                        <th>Email</th>
                        <th>Title</th>
                        <th>Role</th>
                        <th>Assign Role</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{{searchEmaiResponse.title +' '+ searchEmaiResponse.first_name +
                            ' '+searchEmaiResponse.last_name}}
                        </td>
                        <td>{{searchEmaiResponse.phone1}}</td>
                        <td>{{searchEmaiResponse.email}}</td>
                        <td><input type="text" maxlength="32" class="form-control addInputField" required
                                   placeholder="e.g. Building manager"
                                   v-model="title"
                        ></td>
                        <td>
                            <select class="form-control" v-model="building_role_id" name="building_role">
                                <option v-for="(userRole,index) in userRoles" :value="userRole.id">{{userRole.display_name}}</option>
                            </select>
                        </td>
                        <td>
                            <button class="btn  btn-outline-primary" v-on:click="assignRole(searchEmaiResponse.id)">Assign
                                Role
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <DeleteModalComponent v-if="dataToPassToModal.showModal" @close="dataToPassToModal.showModal = false"
                              :confirm="confirm" :dataToPassToModal="dataToPassToModal"
                              :dataObject="userDetails"></DeleteModalComponent>
    </div>
</template>
<style>
    .buildingInformation, .usersAssignedToBuilding {
        margin-top: 10px
    }
</style>
<script>
  import ConnectionService from '../../../../app-model/model'
  import DeleteModalComponent from '../../../../components/modal/DeleteConfirmModalComponent.vue'

  const connectionService = new ConnectionService()
  export default {
    props: {
      buildingId: [String, Number]
    },
    components: {
      DeleteModalComponent
    },
    data () {
      return {
        building_role_id: '',
        title: '',
        response: {
          ifEmailExists: false,
          isEmailResults: false,
          IfRoleAssigned: false,
          isRoleUpdated:false
        },
        id: '',
        buildingDetails: {},
        userDetails: [],
        selected: '',
        userRoles: {},
        searchEmailFormFields: {},
        searchEmaiResponse: {},
        error: [],
        dataToPassToModal: {
          id: '',
          index: '',
          showModal: false,
        },
        roleMessage:''
      }
    },
    created () {
      this.id = this.$route.params.buildingId;
      this.getBuilding();
      this.getBuildingRoles();
      this.getBuildingAccess();
    },
    methods: {
      getBuilding: function() {
        return this.$store.dispatch('apiResult', {
          method: 'GET',
          path: 'api/buildings/' + this.id,
          path_template: '/api/buildings/{id}'
        }).then(response => {
          switch (response.status) {
            case 200 :
              this.buildingDetails = response.data.data
          }
          return response;
        });
      },
      getBuildingRoles: function() {
        return this.$store.dispatch('apiResult', {
          method: 'GET',
          path: 'api/building-roles',
          path_template: '/api/building-roles'
        }).then(response => {
          switch (response.status) {
            case 200:
              this.userRoles = response.data.data
              break;
          }
          return response;
        });
      },
      getBuildingAccess: function() {
        return this.$store.dispatch('apiResult', {
          method: 'GET',
          path: 'api/users/buildings/' + this.id,
          path_template: '/api/users/buildings/{building_id}'
        }).then(response => {
          switch (response.status) {
            case 200 :
              this.userDetails = response.data.data;
              break;
          }
          return response;
        });
      },
      searchUserByEmail: function () {
        this.$store.dispatch('apiResult', {
          method: 'GET',
          path: `api/users/email/${this.id}?email=${encodeURIComponent(this.searchEmailFormFields.email)}`,
          path_template: '/api/users/email/{id}'
        })
          .then(response => {
            switch (response.status) {
              case 404:
                this.response.isEmailResults = false
                connectionService['responseInTime']({
                  responseObject: this.response,
                  value: 'ifEmailExists',
                  status: true
                })
                break
              case 422:
                this.error.email = true
                break
              case 200:
                this.searchEmaiResponse = response.data.data
                this.response.isEmailResults = true
                break
            }
          })
      },
      confirmPopup: function (action, userId, index) {
        this.confirm = {
          action: action,
          title: 'Are you sure to execute: ' + action,
          msg: action + ' will delete this User',
        }
        this.dataToPassToModal.id = this.id
        this.dataToPassToModal.index = index
        this.dataToPassToModal.router = 'api/users/' + userId + '/buildings/'
        this.dataToPassToModal.showModal = true
        this.dataToPassToModal.pathTemplate = '/api/users/{user_id}/buildings/{building_id}'
      },

      updateRole:function (userId, building_role_id, title) {
        this.$store.dispatch('apiResult',{
          method:'put',
          path:`api/users/${userId}/buildings/${this.id}`,
          data:{building_role_id, title},
          path_template: '/api/users/{user_id}/buildings/{building_id}'
        }).then(response => {
            switch (response.status)
            {
              case 200:
                connectionService['responseInTime']({
                  responseObject: this.response,
                  value: 'isRoleUpdated',
                  status: true
                })
                this.roleMessage = response.data.message
            }
        });
      },

      assignRole: function (userId) {
        this.$store.dispatch('apiResult', {
          method: 'post',
          path: 'api/users/' + userId + '/buildings/' + this.id + '/building_role/' + this.building_role_id,
          path_template: '/api/users/{user_id}/buildings/{building_id}/building_role/{building_role_id}',
          data: {title: this.title}
        })
          .then(response => {
            switch (response.status) {
              case 200 :
                this.response.isEmailResults = false
                this.searchEmailFormFields.email = '';
                this.getBuildingAccess();
                break;
              case 422:
                this.roleMessage = response.data.message;
                connectionService['responseInTime']({
                  responseObject: this.response,
                  value: 'IfRoleAssigned',
                  status: true
                });
                break;
            }
          })
      },
      clear (field) {
        delete this.error.userAccount[field]
      },
    },
  }
</script>